var ALIGNMENT = {
  CENTER: 'center',
  END: 'flex-end',
  SPACE_AROUND: 'space-around',
  SPACE_BETWEEN: 'space-between',
  START: 'flex-start'
};

export { ALIGNMENT };
